import {Component, OnInit} from '@angular/core';
import {TestService} from '../../services/api/test.service';
import {TestResultService} from '../../services/api/result/test-result.service';
import {Test, TestsSummary} from '../../data/models/test/test';
import {TestResult, TestResultsSummary} from '../../data/models/result/test-result';
import {Page} from '../../data/models/page';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {

  testsSummary!: TestsSummary;
  testsLastUpdated!: Page<Test>;

  testResultsSummary!: TestResultsSummary;
  testResultsLastFinished!: Page<TestResult>;

  constructor(
    private testService: TestService,
    private testResultService: TestResultService,
  ) {
    this.testService.getTestsSummary()
      .then(testsSummary => {
        this.testsSummary = testsSummary;
      });
    this.testService.searchTests({}, ['updateDate', 'desc'], 10, 0)
      .then(res => {
        this.testsLastUpdated = res;
      });
    this.testResultService.getTestResultsSummary()
      .then(testResultsSummary => {
        this.testResultsSummary = testResultsSummary;
      });
    this.testResultService.searchTestResults({
      isFinished: true,
      isChecked: false,
    }, ['finishDate', 'desc'], 20, 0)
      .then(res => {
        this.testResultsLastFinished = res;
      });
  }

  ngOnInit(): void {
  }

  onWheel(event: WheelEvent, element: Element): void {
    if (event.deltaY !== 0) {
      element.scrollLeft += event.deltaY;
      event.preventDefault();
    }
  }

}
